// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import A11yController from 'utils/a11y_controller';

const a11yController = new A11yController();
export default a11yController;
